import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Box, Button, Modal, Toast } from "native-base";
import AntDesign from '@expo/vector-icons/AntDesign';

import { RootStackParamList } from "../navigation";
import { ActivityIndicator, ImageBackground, Linking, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { useCallback, useEffect, useRef, useState } from "react";
import { PayAPI } from "../data/payApi";
import { UserAPI } from "../data/api";
import { useDispatch } from "react-redux";
import Fontisto from '@expo/vector-icons/Fontisto';
import { useTypedSelector } from "../redux/store";

type Props = NativeStackScreenProps<RootStackParamList, 'ExpertPay'>;

export default function ExpertPayScreen({
  navigation, route
}: Props){
  const { character, images } = route.params || {};

  const dispatch = useDispatch();
  const userCurrent = useTypedSelector((state) => state.userCurrent);
  const [checkoutPlan, setCheckoutPlan] = useState("month");
  const [payLoad, setPayLoad] = useState(false);
  const [checkImage, setCheckImage] = useState(images[0] || "");
  const indexRef = useRef(0);
  const timeInterval = useRef<NodeJS.Timeout>(undefined);

  const updateBgHandle = ()=>{
    let list = images || [];
    if(indexRef.current >= list.length){
      indexRef.current = 0;
    }else{
      indexRef.current++;
    }
    setCheckImage(list[indexRef.current] || "");
  };
  
  const createTimer = ()=>{
    clearInterval(timeInterval.current);
    // let time_num = 0;
    timeInterval.current = setInterval(()=>{
      updateBgHandle();
      // if(time_num % 10 === 0 && time_num > 0){
      // }
    }, 1500);
  };

  const isSubscribed = userCurrent.sub_list.includes(character.name);

  const continueChange = async ()=>{
    if(payLoad) return;
    setPayLoad(true);
    let keyObj: {
      [key: string]: string
    } = {
      "weekly": "price_1REQAaK9oh0lFlzBOeKId71w",
      "month": "price_1RERB9K9oh0lFlzBjbUio4GT"
    }
    let checked = keyObj[checkoutPlan]
    let res = await PayAPI.getPlanUrl(checked, "subscription");
    if(res && res.url){
      window.location.href = res.url;
    }else{
      setPayLoad(false);
      Toast.show({
        title: "Pay failed",
        placement: "top",
        bgColor: "rgba(255,0,0,0.4)" 
      })
    }
    // stripe_key
    // navigation.goBack();
  };

  const unsubscribeChange = async ()=>{
    const url = `mailto:support@snackbook.cc`;
    try {
      const canOpen = await Linking.canOpenURL(url);
      if (canOpen) {
        await Linking.openURL(url);
      } else {
        Toast.show({
          title: "Unable to open email",
          placement: "top",
          bgColor: "rgba(255,0,0,0.4)" 
        })
      }
    } catch (error) {
      Toast.show({
        title: "Unable to open email",
        placement: "top",
        bgColor: "rgba(255,0,0,0.4)" 
      })
    }
  }
  
  useEffect(() => {
    if(userCurrent.subscription){
      let name = character.name;
      for(let item of userCurrent.subscription){
        if(item.includes(name)){
          let subs = item.split("_")[0];
          setCheckoutPlan(subs);
          break;
        } 
      }
    }
  },[userCurrent]);
  
  useEffect(()=>{
    createTimer();
    UserAPI.getCurrentUser(dispatch);
    return ()=>{
      clearInterval(timeInterval.current); 
    }
  }, []);

  const PriceComponent = useCallback(({
    name, pay_key
  }:{
    name: string, pay_key: string
  })=>{
    return (
      <TouchableOpacity style={{
        flexDirection: "row", alignItems: "center",
        padding: 12, borderWidth: 2, position: "relative",
        borderColor: checkoutPlan === pay_key ? "rgb(179,88,251)" : "transparent",
        borderRadius: 12,
      }} onPress={()=> setCheckoutPlan(pay_key) }>
        {pay_key === "month" && (
          <View style={{
            position: "absolute", top: -8, right: 14,
            height: 16, paddingLeft: 10, paddingRight: 10,
            alignItems: "center", borderRadius: 10,
            backgroundImage: "linear-gradient(to right, rgb(148,9,255), rgb(173,8,255))",
          }}>
            <Text style={{
              fontSize: 12, color: "#FFFFFF", fontWeight: "bold"
            }}>
              BEST OFFER
            </Text>
          </View>
        )}
        <Text style={{ fontSize: 14, color: "#FFFFFF", fontWeight: "bold" }}>
          {name}
        </Text>
        <View style={{ flex: 1 }}></View>
        { pay_key === "weekly" ? (
          <>
            <Text style={{ fontSize: 13, color: "#FFFFFF", fontWeight: "bold" }}>
              $4.99 / weekly
            </Text>
          </>
        ) : (
          <>
            <Text style={{
              fontSize: 13, color: "rgb(173,8,255)", fontWeight: "bold",
              marginLeft: 4, marginRight: 10
            }}>
              20% off
            </Text>
            <Text style={{ fontSize: 13, color: "#FFFFFF", fontWeight: "bold" }}>
              $17.99 / month
            </Text>
          </>
        ) }
      </TouchableOpacity> 
    )
  },[checkoutPlan]);

  const DescBox = useCallback(({
    icons, desc 
  }:{
    icons: string, desc: string
  })=>(
    <View style={{ flexDirection: "row", gap: 10, alignItems: "center" }}>
      <Text style={{ fontSize: 14 }}>
        {icons}
      </Text>
      <Text style={{ fontSize: 14, color: "#FFFFFF" }}>
        {desc}
      </Text>
    </View>
  ),[])

  return (
    <ImageBackground source={{uri: checkImage }}
      style={{ flex: 1, overflow: "hidden" }}>
      <Button style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        borderRadius: 100, position: "absolute",
        top: 10, left: 10, padding: 4, zIndex: 10,
      }} onPress={()=> {
        clearInterval(timeInterval.current);
        navigation.goBack()
      } }>
        <AntDesign name="close" size={24} color="#AAAAAA" />
      </Button>
      <View style={styles.nav_right_ctx}>
        <Fontisto name="database" size={12} color="#FFFFFF" />
        <Text style={{ color: '#FFFFFF', fontSize: 14 }}>{userCurrent.coins}</Text>
      </View>
      <View style={{ flex: 1, justifyContent: "flex-end" }}>
        <View style={{
          padding: 16, paddingTop: 100, paddingBottom: 0,
          backgroundImage: "linear-gradient(to top, rgba(25,27,44, 1) 0%, rgba(25,27,44, 1) 20%, rgba(0,0,0,0))",
        }}>
          <View style={{
            alignItems: "center", paddingBottom: 16,
          }}>
            <Text style={{
              fontSize: 24, fontWeight: "bold", color: "#FFFFFF"
            }}>
              Get closer with
            </Text>
            <Text style={{
              fontSize: 24, fontWeight: "bold", color: "#FFFFFF" 
            }}>
              {character?.role_name}
            </Text>
          </View>
          <View style={{ gap: 10 }}>
            <DescBox icons="👧" desc="Dialogues like a real girl" />
            <DescBox icons="💕" desc="The full experience of a relationship" />
            <DescBox icons="📞" desc="Online phone chat" />
            <DescBox icons="🎁" desc={
              checkoutPlan === "weekly" ?
                "5,000 Coins Per Week" : "20,000 Coins Per Month"
              } />
          </View>
        </View>

        <View style={{ backgroundColor: "#191B2C", padding: 16 }}>
          {isSubscribed ? (
            <View style={{ gap: 10 }}>
              <Text style={{
                color: "#FFFFFF", fontSize: 16, fontWeight: "bold",
                textAlign: "center"
              }}>
                ✨ You have subscribed to Jeni ✨
              </Text>
              <Text style={{
                color: "#FFFFFF", fontSize: 16, fontWeight: "bold",
                textAlign: "center"
              }}>
                Enjoy all privileges
              </Text>
            </View>
          ):(
            <View style={{ gap: 10 }}>
              <PriceComponent name="WEEKLY" pay_key="weekly" />
              <PriceComponent name="MONTHLY" pay_key="month" />
            </View>
          )}

          <Text style={{
            color: "#515685", fontSize: 12, textAlign: "center",
            marginBottom: 10, marginTop: 10,
          }}>
            Autorenewable subscription
          </Text>
          {isSubscribed ? (
            <TouchableOpacity style={{
              height: 54, borderRadius: 10, paddingLeft: 10, paddingRight: 10,
              backgroundColor: "rgb(65, 66, 73)",
              gap: 4, marginBottom: 6,
              alignItems: "center", justifyContent: "center"
            }} onPress={unsubscribeChange}>
              <Text style={{
                fontSize: 18, color: "#FFFFFF", fontWeight: "700"
              }}>Unsubscribe</Text>
              <Text style={{
                fontSize: 12, color: "#FFFFFF", fontWeight: "700"
              }}>mail: support@snackbook.cc</Text>
            </TouchableOpacity>
          ):(
            <TouchableOpacity style={{
              height: 54, borderRadius: 10, paddingLeft: 10, paddingRight: 10,
              backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
              flexDirection: "row", gap: 10, marginBottom: 6,
              alignItems: "center", justifyContent: "center"
            }} onPress={continueChange}>
              <Text style={{
                fontSize: 18, color: "#FFFFFF", fontWeight: "700"
              }}>Continue</Text>
            </TouchableOpacity>
          )}
          

          <Text style={{
            color: "#FFFFFF", fontSize: 14, fontWeight: "bold",
            textAlign: "center"
          }}>
            🔥 65 756 people went Pro this week 🔥
          </Text>
        </View>
      </View>
      
      <Modal isOpen={payLoad} size="full" bg="black.700:alpha.70"
        justifyContent="center" alignItems="center"
        style={{
          width: "100%", maxWidth: 460,
          marginLeft: "auto", marginRight: "auto",
        }}>
        <ActivityIndicator size="large" color="#FFFFFF" />
      </Modal>
    </ImageBackground>
  )
};

const styles = StyleSheet.create({
  nav_right_ctx: {
    position: "absolute",
    top: 12,
    right: 6,
    zIndex: 9,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    borderRadius: 20,
    padding: 2,
    paddingLeft: 12,
    paddingRight: 12,
    borderWidth: 1,
    borderColor: "#007AFF",
    borderStyle: "solid",
    backgroundColor: "rgba(0,0,0,0.5)"
  }
})